<template>
  <div id="order">
    <a-modal
      title="选取位置"
      style="top: 20px"
      :width="800"
      v-model="mapVisible"
      @ok="mapVisible = false"
      @cancel="mapVisible = false"
    >
      <lonlat-map ref="lonlatMaps" @handleMapOk="handleMapOk"></lonlat-map>
    </a-modal>
    <a-modal
      title="派发工单"
      :visible="showTubeView"
      :width="800"
      destroyOnClose
      @ok="handleOk"
      @cancel="closeTubeView"
    >
      <!-- style="position: absolute; left: 18rem; z-index: 999; top: 3rem" -->
      <a-form-model
        class="log-form"
        :model="addOrUpdateForm"
        ref="addOrUpdateForm"
        :rules="rules"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 14 }"
      >
        <a-row class="form-row" type="flex" justify="center" :gutter="4">
          <a-col :md="12" :sm="24">
            <a-form-model-item label="关联事件">
              <span>{{ addOrUpdateForm.eventNo }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="工单号">
              <a-input disabled placeholder="自动生成"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="工单类型" prop="workOrderType">
              <a-select placeholder="请选择工单类型" v-model="addOrUpdateForm.workOrderType">
                <a-select-option v-for="item in OrderTypeList" :key="item.dictValue">{{
                  item.dictValue
                }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="工单内容" prop="deviceName">
              <a-input v-model="addOrUpdateForm.deviceName" />
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="负责人" prop="principal">
              <a-select
                show-search
                option-filter-prop="children"
                style="width: 200px"
                :filter-option="filterOption"
                v-model="addOrUpdateForm.principal"
                @change="handleChange"
              >
                <a-select-option v-for="item in userlist" :key="item.id">{{ item.realName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="是否需要停水事件" prop="isWaterOffEvent" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
              <a-radio-group v-model="addOrUpdateForm.isWaterOffEvent" @change="WaterOffEventchange">
                <a-radio :value="0">否</a-radio>
                <a-radio :value="1">是</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <div v-if="WaterOf">
            <a-col :md="24" :sm="24">
              <a-form-model-item label="事件名称" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="eventName">
                <a-input v-model="addOrUpdateForm.eventName" />
              </a-form-model-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-model-item label="爆管管段">
                <a-button type="primary" @click="openMap">选择爆管管段</a-button>
              </a-form-model-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-model-item label="停水管理员" prop="waterAdminId">
                <a-select
                  show-search
                  option-filter-prop="children"
                  :filter-option="filterOption"
                  v-model="addOrUpdateForm.waterAdminId"
                >
                  <a-select-option v-for="item in userlist" :key="item.id">{{ item.realName }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-model-item label="开始分类编码" prop="startClassNo">
                <a-input v-model="addOrUpdateForm.startClassNo" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-model-item label="结束分类编码" prop="startClassNo">
                <a-input v-model="addOrUpdateForm.endClassNo" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-model-item label="计划停水开始时间" prop="startValues">
                <a-date-picker
                  v-model="addOrUpdateForm.startValues"
                  :disabled-date="disabledStartDates"
                  @change="onChangehs"
                  format="YYYY-MM-DD HH:mm:ss"
                  @openChange="handleStartOpenChanges"
                />
              </a-form-model-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-model-item label="计划停水结束时间" prop="endValues">
                <a-date-picker
                  v-model="addOrUpdateForm.endValues"
                  :disabled-date="disabledEndDates"
                  format="YYYY-MM-DD HH:mm:ss"
                  :open="endOpens"
                  @change="onChangets"
                  @openChange="handleEndOpenChanges"
                />
              </a-form-model-item>
            </a-col>

            <a-col :md="24" :sm="24">
              <a-form-model-item label="事件描述" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }" prop="describe">
                <a-textarea placeholder="多行输入" v-model="addOrUpdateForm.describe" :rows="3" />
              </a-form-model-item>
            </a-col>
          </div>
          <a-col :md="24" :sm="24">
            <a-form-model-item label="维修地点" style="width: 376px">
              <a-button type="primary" @click="showmap">添加位置</a-button>
            </a-form-model-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <a-form-model-item label="维修地点" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <a-textarea placeholder="多行输入" v-model="addOrUpdateForm.address" :rows="2" />
            </a-form-model-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <a-form-model-item label="坐标" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <a-input v-model="addOrUpdateForm.place" />
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item
              label="协办人"
              :label-col="{ span: 4 }"
              :wrapper-col="{ span: 20 }"
              style="margin-left: 37px"
            >
              <a-button @click="addSponsor" style="margin-right: 20px">添加</a-button>
              <a-tag v-for="item in assistPersonsList" :key="item.key" closable @close="delSponsor(item.key)">{{
                item.title
              }}</a-tag>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="督办人" :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }">
              <a-button @click="addSupervisor" style="margin-right: 20px">添加</a-button>
              <a-tag v-for="item in maintainPersonsList" :key="item.key" closable @close="delMaintain(item.key)">{{
                item.title
              }}</a-tag>
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="开始时间" prop="startValue">
              <a-date-picker
                v-model="addOrUpdateForm.startValue"
                :disabled-date="disabledStartDate"
                @change="onChanges"
                format="YYYY-MM-DD"
                @openChange="handleStartOpenChange"
              />
            </a-form-model-item>
          </a-col>
          <a-col :md="12" :sm="24">
            <a-form-model-item label="完成时间" prop="endValue">
              <a-date-picker
                v-model="addOrUpdateForm.endValue"
                :disabled-date="disabledEndDate"
                format="YYYY-MM-DD"
                :open="endOpen"
                @change="onChanget"
                @openChange="handleEndOpenChange"
              />
            </a-form-model-item>
          </a-col>
          <a-col :md="24" :sm="24">
            <a-form-model-item label="备注" :label-col="{ span: 3 }" :wrapper-col="{ span: 20 }">
              <a-textarea placeholder="多行输入" v-model="addOrUpdateForm.remarks" :rows="2" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <addModal ref="addModal" @addPepople="addPepople"></addModal>
      <a-modal class="log-form" :title="'选取位置'" width="50%" v-model="showMap" @ok="closeMap" @cancel="closeMap2">
        <input class="login-input" type="text" v-model="startLine" placeholder="请输入开始分类编码" />
        <input class="login-input" type="text" v-model="endLine" placeholder="请输入结束分类编码" />
        <a-button type="submit" @click="searchMapLine">查询</a-button>
        <mapTemplate ref="waterMap" @childByValue="childByValue"></mapTemplate>
      </a-modal>
    </a-modal>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import moment from 'moment'
import addModal from './AddModal'
import LonlatMap from '../../../maintenance/EventManagement/modules/lonlatMap.vue'
import mapTemplate from '@/views/Water-outage-control/map-template.vue'
export default {
  components: {
    addModal,
    LonlatMap,
    dayjs,
    mapTemplate
  },
  data() {
    return {
      dayjs,
      endOpen: false,
      queryUrl: '/pipe-network/user_water_meters/page/geophysical-point-numbers',
      exportFileName: '影响用户数据.xlsx',
      exportDataUrl: 'pipe-network/user_water_meters/export',
      showTubeView: false,
      endOpens: false,
      WaterOf: false,
      id: '',
      startLine: '',
      endLine: '',
      showMap: false,
      addOrUpdateForm: {
        predictStime: '',
        predictEtime: '',
        deviceNo: '',
        deviceName: '',
        principal: '',
        workOrderType: '',
        remarks: '',
        assistPersons: [],
        maintainPersons: [],
        place: '',
        waterAdminId: '',
        eventName: '',
        endValue: '',
        startValue: '',
        startValues: '',
        endValues: '',
        isWaterOffEvent: '',
        isRelationWaterOffEvent: 0,
        adminId: '',
        waterAdminName: '',
        startClassNo: '',
        endClassNo: '',
        describe: '',
        lineId: ''
      },
      zoneTreeData: [], // 分区数据选项
      eventTypeList: [],
      OrderTypeList: [], // 工单类型
      userlist: [],
      assistPersonsList: [],
      maintainPersonsList: [],
      selectButton: '',
      mapVisible: false
    }
  },
  computed: {
    rules() {
      return {
        deviceName: [{ required: true, message: '请输入工单内容', trigger: 'change' }],
        workOrderType: [{ required: true, message: '请选择工单类型', trigger: 'change' }],
        principal: [{ required: true, message: '请选择负责人', trigger: 'change' }],
        maintainPersons: [{ required: true, message: '请选择督办人', trigger: 'change' }],
        assistPersons: [{ required: true, message: '请选择协办人', trigger: 'change' }],
        waterAdminId: [{ required: true, message: '请选择停水管理员', trigger: 'change' }],
        startValue: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
        endValue: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
        address: [{ required: true, message: '请选择地址', trigger: 'change' }],
        description: [{ required: true, message: '请输入任务描述', trigger: 'change' }],
        eventName: [{ required: true, message: '请输入事件名称', trigger: 'change' }],
        startValues: [{ required: true, message: '请选择停水开始时间', trigger: 'change' }],
        endValues: [{ required: true, message: '请选择停水结束时间', trigger: 'change' }],
        describe: [{ required: true, message: '请输入事件描述', trigger: 'change' }],
        startClassNo: [{ required: true, message: '请输入开始分类编码', trigger: 'change' }],
        endClassNo: [{ required: true, message: '请输入结束分类编码', trigger: 'change' }]
      }
    }
  },
  created() {
    this.getUserList()
    this.getOrderTypeList()
  },
  methods: {
    childByValue(childValue) {
      this.startLine = childValue[0].properties.start_class_no
      this.endLine = childValue[0].properties.end_class_no
      this.addOrUpdateForm.lineId = childValue[0].id.substr(childValue[0].id.lastIndexOf('.') + 1, 20)
    },
    moment,
    openMap() {
      this.showMap = true
      this.$refs.waterMap.redSource.clear()
    },
    closeMap() {
      this.addOrUpdateForm.endClassNo = this.endLine
      this.addOrUpdateForm.startClassNo = this.startLine
      this.startLine = ''
      this.endLine = ''
      this.showMap = false
      this.$refs.waterMap.redSource.clear()
    },
    closeMap2() {
      this.showMap = false
      this.startLine = ''
      this.endLine = ''
      this.$refs.waterMap.redSource.clear()
    },
    searchMapLine() {
      this.$refs.waterMap.searchLines(this.startLine, this.endLine)
    },
    showmap() {
      this.mapVisible = true
    },
    disabledStartDates(current) {
      return current && current < dayjs().endOf('day')
    },
    disabledEndDates(endValue) {
      const startValue = this.addOrUpdateForm.startValues
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChanges(open) {
      if (!open) {
        this.endOpens = true
      }
    },
    handleEndOpenChanges(open) {
      this.endOpens = open
    },
    onChangehs(date, dateString) {
      this.addOrUpdateForm.planStartTime = dateString
    },
    onChangets(date, dateString) {
      this.addOrUpdateForm.planEntTime = dateString
    },
    // 停水
    WaterOffEventchange(value) {
      if (value.target.value == 1) {
        this.WaterOf = true
      } else {
        this.WaterOf = false
      }
    },
    // 时间
    disabledStartDate(current) {
      return current && current < dayjs().endOf('day')
    },
    disabledEndDate(endValue) {
      const startValue = this.addOrUpdateForm.startValue
      if (!endValue || !startValue) {
        return false
      }
      return startValue.valueOf() >= endValue.valueOf()
    },
    handleStartOpenChange(open) {
      if (!open) {
        this.endOpen = true
      }
    },
    handleEndOpenChange(open) {
      this.endOpen = open
    },
    onChanges(value, dateString) {
      this.addOrUpdateForm.predictStime = dateString + ' 00:00:00'
    },
    onChanget(value, dateString) {
      this.addOrUpdateForm.predictEtime = dateString + ' 00:00:00'
    },
    handleMapOk(data) {
      this.addOrUpdateForm.address = data.address
      this.addOrUpdateForm.place = data.point
      console.log(this.addOrUpdateForm.address)
      console.log(this.addOrUpdateForm.place)
    },
    getOrderTypeList() {
      const params = {
        dictCode: 'CHECKING-THE-REPAIR-ORDER'
      }
      this.$http.get('/manager/dicts/children', { params }).then(({ data }) => {
        this.OrderTypeList = data
      })
    },
    addSupervisor() {
      this.selectButton = 'Supervisor'
      this.$refs.addModal.edit(this.addOrUpdateForm.maintainPersons)
    },
    addSponsor() {
      this.selectButton = 'Sponsor'
      this.$refs.addModal.edit(this.addOrUpdateForm.assistPersons)
    },
    addPepople(list) {
      if (this.selectButton == 'Sponsor') {
        this.assistPersonsList = list
        this.addOrUpdateForm.assistPersons = []

        list.length
          ? list.map((item) => {
              this.addOrUpdateForm.assistPersons.push(item.key)
            })
          : ''
        console.log(this.assistPersonsList)
        console.log(this.addOrUpdateForm.assistPersons)
      } else {
        this.maintainPersonsList = list
        this.addOrUpdateForm.maintainPersons = []
        list.length
          ? list.map((item) => {
              this.addOrUpdateForm.maintainPersons.push(item.key)
            })
          : ''
      }
    },
    delMaintain(key) {
      const i = this.maintainPersonsList.findIndex((item) => {
        return item.key == key
      })
      this.maintainPersonsList.splice(i, 1)
      const j = this.addOrUpdateForm.maintainPersons.indexOf(key)
      this.addOrUpdateForm.maintainPersons.splice(j, 1)
    },
    delSponsor(key) {
      const i = this.assistPersonsList.findIndex((item) => {
        return item.key == key
      })
      this.assistPersonsList.splice(i, 1)
      const j = this.addOrUpdateForm.assistPersons.indexOf(key)
      this.addOrUpdateForm.assistPersons.splice(j, 1)
    },
    handleChange(value) {
      this.addOrUpdateForm.principal = value
    },
    getUserList() {
      this.$http.get('/manager/users/list').then(({ data }) => {
        this.userlist = data
      })
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    beginOnChange(value, dateString) {
      this.addOrUpdateForm.predictStime = dateString
    },
    endOnChange(value, dateString) {
      this.addOrUpdateForm.predictEtime = dateString
    },
    edit(records) {
      console.log(JSON.stringify(records))
      this.showTubeView = true
      ;(this.addOrUpdateForm = {
        eventNo: records.eventNo,
        deviceName: '',
        principal: '',
        predictStime: '',
        workOrderType: '',
        isRelationWaterOffEvent: 0,
        waterAdminName: '',
        adminId: '',
        waterAdminId: '',
        predictEtime: '',
        endValue: '',
        startValue: '',
        startClassNo: '',
        endClassNo: ''
      }),
        this.$nextTick(() => {
          this.$refs.addOrUpdateForm.resetFields()
          this.addOrUpdateForm.eventId = records.id
          this.addOrUpdateForm.eventNo = records.eventNo
        })
    },
    // 获取数据
    getDataList() {
      this.dataListLoading = true
      const params = {
        geophysicalPointNumber: this.id,
        // geophysicalPointNumber: 'JS581',
        page: this.pagination.current,
        limit: this.pagination.pageSize
      }
      this.$http
        .get(this.queryUrl, {
          params
        })
        .then(({ data }) => {
          this.dataListLoading = false
          this.dataList = data.list || []
          this.pagination.total = data.total ? parseInt(data.total) : 0
        })
        .catch(() => {
          this.dataListLoading = false
        })
    },
    handleOk(e) {
      e.preventDefault()
      this.$refs.addOrUpdateForm.validate((valid) => {
        if (valid) {
          this.$http
            .post('/pipe-network/inspection_tasks/dispatch/work/order', {
              id: this.currentId,
              sysType: '巡检',
              ...this.addOrUpdateForm
            })
            .then((res) => {
              if (res.code === 0) {
                this.closeTubeView()
                this.$emit('handleOk')
                this.WaterOf = false
                return this.$message.success(res.message)
              }
            })
            .catch(() => {})
        }
      })
    },
    closeTubeView() {
      this.showTubeView = false
      this.$refs.addOrUpdateForm.resetFields()
      this.assistPersonsList = []
      this.maintainPersonsList = []
      this.WaterOf = false
      this.$emit('handleOk')
    }
  }
}
</script>

<style lang="less" scoped></style>
